import React, { useState } from "react";
import { Flex } from "rebass/styled-components";
import { MobileDownload } from "../../../Button";
import { More } from "./Components/MoreClipOptionsDropdown";
import { CopyLink } from "../../../Button/Share";
import { ClipShare } from "../../../Button/Share";
import { Button } from "../../../Button";
import { HiDownload } from "react-icons/hi";
import { useUser } from "../../../../Hooks/useUser";
import styled from "styled-components";

import { HideOnNarrow } from "../../../Wrappers";

export function ClipOptions({
  clip,
  classification,
  onClick,
  isMontage,
  isProfile,
  onDownloadClick,
  isOwnClip,
  isFeed,
  setDownloadModalOpen,
  setShareModalOpen,
  setReportModalOpen,
  setModalOpen,
  setEditModalOpen,
  mobileView,
  clipLink,
  hideOnMobile,
}: any) {
  classification = classification ? classification : "secondary";

  const { allstarUser } = useUser();
  const [_, setAuthModalOpen] = useState(false); //eslint-disable-line
  const canShowMobileOption = isOwnClip || allstarUser?.user?.admin;

  return (
    <>
      <ColumnAtSmall isFeed={isFeed} mobileView={mobileView}>
        <ClipShare
          title="Share Clip"
          clip={clip}
          clipLink={clipLink}
          onClick={() => {
            setShareModalOpen(true);
          }}
        ></ClipShare>
        {canShowMobileOption && (
          <MobileDownload
            size="social"
            clip={clip}
            clipLink={clipLink}
            onClick={() => {
              if (!allstarUser?.user) return setAuthModalOpen(true);
              setDownloadModalOpen(true);
            }}
          />
        )}
        {!hideOnMobile && isFeed && (
          <>
            {isProfile ? (
              <>
                <HideOnNarrow>
                  <CopyLink
                    clip={clip}
                    clipLink={clipLink}
                    onClick={onClick}
                    isMontage={isMontage}
                    isProfile={isProfile}
                  ></CopyLink>
                </HideOnNarrow>
              </>
            ) : (
              <>
                {" "}
                <CopyLink
                  clip={clip}
                  clipLink={clipLink}
                  onClick={onClick}
                  isMontage={isMontage}
                  isProfile={isProfile}
                ></CopyLink>
              </>
            )}
          </>
        )}
        {isFeed && hideOnMobile && (
          <Button
            title="Download Clip"
            display="flex"
            classification="secondaryRounded"
            justifyContent="center"
            alignContent="center"
            alignItems="center"
            clip={clip}
            clipLink={clipLink}
            onClick={(e: any) => {
              if (allstarUser?.loggedIn) {
                onDownloadClick();
              } else {
                return setAuthModalOpen(true);
              }
            }}
          >
            <StyledDownload size={18} />
          </Button>
        )}
        <More
          size="social"
          classification={classification}
          clip={clip}
          clipLink={clipLink}
          isOwnClip={isOwnClip}
          isProfile={isProfile}
          isMontage={isMontage}
          onDownloadClick={onDownloadClick}
          setReportModalOpen={setReportModalOpen}
          setEditModalOpen={setEditModalOpen}
          setModalOpen={setModalOpen}
          setDownloadModalOpen={setDownloadModalOpen}
          setShareModalOpen={setShareModalOpen}
        />
      </ColumnAtSmall>
    </>
  );
}

const StyledDownload = styled(HiDownload)`
  position: relative;
`;

const ColumnAtSmall = styled<any>(Flex)`
  justify-content: space-between;
  gap: 10px;
  ${(props) =>
    props.mobileView && "flex-direction: row; justify-content: space-between; "}
  ${(props) => props.isFeed && "justify-content: flex-end;"}

  @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
    ${(props) => props.mobileView && "flex-direction: row;"}
    ${(props) => props.isFeed && "justify-content: space-between; gap: 5px;"}
  }
`;
